module.exports = __webpack_public_path__ + "static/media/lightwhitephoto.1778f0ff.jpg";